/*****************************************************************
 * Generated by RxDjango on 2026-07-16 17:19 (UTC)               *
 *                                                               *
 * Based on all ContextChannel subclasses in task_board.channels *
 *                                                               *
 *                     DO NOT EDIT THIS FILE                     *
 *                                                               *
 * To rebuild it, run:                                           *
 *                                                               *
 *     ./manage.py makefrontend [task_board]                     *
 *                                                               *
 *****************************************************************/

import { ContextChannel } from '@rxdjango/react';
import type { Task } from './task_board.models';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class TaskBoardChannel extends ContextChannel {

  protected endpoint: string = "/ws/task_board/";
  protected baseURL: string = SOCKET_URL;

  tasks: Task[] | null = null;

  protected _modelFields: Record<string, {
      anchor: string;
      model: Record<string, Record<string, string>>;
      many?: boolean;
    }> = {
      "tasks": {
        anchor: "task_board.serializers.TaskSerializer",
        many: true,
        model: {
          "task_board.serializers.TaskSerializer": {  },
        },
      },
    };

  select_project = async (project_id: number) => {
    return await this.rx.callAction('select_project', [project_id]);
  };

  add_task = async (name: string, priority: number) => {
    return await this.rx.callAction('add_task', [name, priority]);
  };

  move_task = async (task_id: number, project_id: number) => {
    return await this.rx.callAction('move_task', [task_id, project_id]);
  };

  toggle_status = async (task_id: number) => {
    return await this.rx.callAction('toggle_status', [task_id]);
  };

  bump_priority = async (task_id: number, delta: number) => {
    return await this.rx.callAction('bump_priority', [task_id, delta]);
  };

  delete_task = async (task_id: number) => {
    return await this.rx.callAction('delete_task', [task_id]);
  };
}
